import { createAction } from 'typesafe-actions';

import {
  GetMobilePrinterListPayload,
  SetMobilePrinterListPayload,
  MobilePrinterErrorPayload,
  TestMobilePrinterConnectionPayload,
  TestMobilePrinterConnectionErrorPayload,
} from './mobilePrinter.types';

export const getMobilePrinterList = createAction('GET_MOBILE_PRINTER_LIST')<GetMobilePrinterListPayload>();

export const setMobilePrinterList = createAction('SET_MOBILE_PRINTER_LIST')<SetMobilePrinterListPayload>();

export const mobilePrinterListError = createAction('MOBILE_PRINTER_LIST_ERROR')<MobilePrinterErrorPayload>();

export const resetMobilePrinter = createAction('CLEAR_MOBILE_PRINTER')();

export const testMobilePrinterConnection = createAction('TEST_MOBILE_PRINTER_CONNECTION')<
  TestMobilePrinterConnectionPayload
>();

export const testMobilePrinterConnectionSuccess = createAction('TEST_MOBILE_PRINTER_CONNECTION_SUCCESS')();

export const testMobilePrinterConnectionError = createAction('TEST_MOBILE_PRINTER_CONNECTION_ERROR')<
  TestMobilePrinterConnectionErrorPayload
>();

export const testMobilePrinterConnectionWarning = createAction('TEST_MOBILE_PRINTER_CONNECTION_WARNING')();

export const resetTestMobilePrinterConnection = createAction('RESET_TEST_MOBILE_PRINTER_CONNECTION')();
